import { NgModule } from '@angular/core';

import { PriceBaseService2 } from './price-base.service';
import { PriceService2 } from './price.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        PriceService2,
        PriceBaseService2,
    ],
})
export class PriceModule2 {}
